import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import storage from "../../../apis/Storage";
import {
  GET_GLOBAL_SETTINGS,
  ADD_GLOBAL_SETTING,
  DELETE_GLOBAL_SETTING,
  UPDATE_GLOBAL_SETTING,
} from "../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";

export const getGlobalSettings = () => async (dispatch) => {
  await axios
    .get(`api/AppGlobalSetting`)
    .then(({ data }) => {
      //debugger;
      dispatch({
        type: GET_GLOBAL_SETTINGS,
        payload: data.response,
      });
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const addGlobalSetting = (formValues) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post("api/AppGlobalSetting", formValues)
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: ADD_GLOBAL_SETTING,
          payload: data.response,
        });
      dispatch(hideLoading());
      toast.success("App Global Setting added successfully");
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const deleteGlobalSetting = (id) => async (dispatch) => {
  const config = {
    headers: { Authorization: `Bearer ${storage.get("_appToken")}` },
  };

  await axios
    .delete(`api/AppGlobalSetting/${id}`, config)
    .then(() => {
      toast.success("App Global Setting deleted successfully");
      dispatch({ type: DELETE_GLOBAL_SETTING, payload: id });
    })
    .catch(function (error) {
      dispatch(hideLoading());
      toast.error("Error: " + error);
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const updateGlobalSetting = (id, formValues) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .put(`api/AppGlobalSetting/${id}`, formValues)
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: UPDATE_GLOBAL_SETTING,
          payload: data.response,
        });
      dispatch(hideLoading());
      toast.success("App Global Setting updated successfully");
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};
